import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-spinner.tsx
/**
* icon.24.spinner
*
* Keywords: refresh, reload, clockwise, rotation, circular, arrow, update, sync
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTUuMzMzIDcuMDExYTYgNiAwIDAgMC0yLjgzNC0uOTlBLjUzNC41MzQgMCAwIDEgMTIgNS41YzAtLjI3Ni4yMjQtLjUwMi41LS40ODJBNyA3IDAgMSAxIDUuMDE4IDEyLjUuNDczLjQ3MyAwIDAgMSA1LjUgMTJjLjI3NiAwIC40OTguMjI0LjUyLjVhNiA2IDAgMSAwIDkuMzEzLTUuNDg5IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-2000
*/
const Icon24Spinner = memo(function Icon24Spinner(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M15.333 7.011a6 6 0 0 0-2.834-.99A.534.534 0 0 1 12 5.5c0-.276.224-.502.5-.482A7 7 0 1 1 5.018 12.5.473.473 0 0 1 5.5 12c.276 0 .498.224.52.5a6 6 0 1 0 9.313-5.489",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24Spinner };

//# sourceMappingURL=icon-24-spinner.js.map